<template>
  <div class="tw-relative tw-overflow-auto" :data-test-id="`${testId}-stepper`">
    <ol class="tw-flex tw-w-full tw-items-center tw-text-center">
      <li
        v-for="(step, i) in props.steps"
        :key="step.index"
        class="tw-relative tw-flex tw-items-center"
        :data-test-id="`${testId}-stepper-step-${i}`"
        :class="{
          [`after:tw-border-1 after:tw-mx-6 after:tw-hidden after:tw-h-1 after:tw-w-full after:tw-border-b after:tw-border-dorian-gray-100 sm:after:tw-inline-block sm:after:tw-content-[''] md:tw-w-full xl:after:tw-mx-10`]:
            i !== props.steps.length - 1,
        }"
      >
        <span
          class="tw-relative tw-flex tw-items-center tw-text-dorian-gray-500"
          :class="{
            [`after:tw-mx-2 after:tw-text-dorian-gray-100 after:tw-content-['/'] sm:after:tw-hidden`]:
              i !== props.steps.length - 1,
          }"
        >
          <ClIconTablerCircleCheck
            v-if="step.completed"
            :width="'16px'"
            :height="'16px'"
            class="tw-select-none tw-text-secondary-500"
          />
          <span
            v-else
            class="tw-select-none tw-text-base tw-font-medium"
            :class="{
              'tw-text-secondary-500': step.current,
            }"
          >
            {{ step.index }}
          </span>
          <span
            class="tw-ml-2.5 tw-inline-flex tw-whitespace-nowrap tw-text-base tw-font-medium tw-underline-offset-1 hover:tw-cursor-pointer hover:tw-underline"
            :class="{
              'tw-text-dorian-gray-200': step.completed,
              'tw-text-secondary-500': step.current,
              'tw-pointer-events-none': !step.actionable,
            }"
            @click="emitClick(step.index)"
          >
            {{ step.label }}
          </span>
        </span>
      </li>
    </ol>
  </div>
</template>

<script lang="ts" setup>
import { ClIconTablerCircleCheck } from "../icons";

import type { Step } from "./types";

export interface SpinnerProps {
  steps: Step[];
  testId?: string;
}

const props = withDefaults(defineProps<SpinnerProps>(), {
  testId: "",
});

const emit = defineEmits<{
  (event: "on-Click", index: number): void;
}>();

const emitClick = (index: number): void => {
  emit("on-Click", index);
};
</script>

<style scoped></style>
